import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import ReportBox from './ReportBox';
import Money from '../../../common/money';
import Day from '../../../common/date';

const Deposits = ({ upcomingDeposits, lastDepositAmount, lastDepositDate }) => (
  <ReportBox title={t('reports:dashboard.deposits')}>
    <div className="u-text-center u-ph+">
      <div className="c-report-stat c-report-stat--large u-mt+ u-mb--">
        <Money automationId="text:upcomingDepositsAmount">{upcomingDeposits}</Money>
      </div>
      <div className="c-report-label u-mb+">{t('reports:dashboard.upcoming_deposits')}</div>
      <div className="c-horizontal-divider" />
      <div className="c-report-stat u-mt+ u-mb-">
        <Money automationId="text:lastDepositAmount">{lastDepositAmount}</Money>
      </div>
      <div className="c-report-label">
        {t('reports:dashboard.last_deposit')} &#124; <Day automationId="text:lastDepositDate">{lastDepositDate}</Day>
      </div>
    </div>
  </ReportBox>
);
Deposits.propTypes = {
  upcomingDeposits: PropTypes.number.isRequired,
  lastDepositAmount: PropTypes.number.isRequired,
  lastDepositDate: PropTypes.string.isRequired,
};
Deposits.defaultProps = {};

export default Deposits;
